import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

// Components
import { MarkDownText } from '../components/Text'

// Utils
import { useAppDispatch } from '../context/AppContext'

// Returns a guard that, when the modal is dirty, asks the user to confirm
// discarding their unsaved changes before running the real close. When clean it
// closes straight through, so consumers can wrap every close path unconditionally.
export const useDiscardGuard = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  return useCallback(
    (isDirty: boolean, onConfirm: () => void) => {
      if (!isDirty) return onConfirm()
      dispatch({
        type: 'updateAlertPopup',
        payload: {
          subtitle: t('general.areYouSure'),
          title: t('general.unsavedChanges.title'),
          content: React.createElement(
            MarkDownText,
            { textAlign: 'center' },
            t('general.unsavedChanges.text')
          ),
          dismissButton: 'general.actions.cancel',
          actionButton: 'general.actions.discardChanges',
          // content.onSubmit takes priority over App's auto-clear, so dismiss the
          // popup ourselves before closing. Cancel auto-clears via App.
          onSubmit: () => {
            dispatch({ type: 'updateAlertPopup', payload: undefined })
            onConfirm()
          },
        },
      })
    },
    [dispatch, t]
  )
}
